import { action, autorun, observable } from 'mobx';

import { getRecaptchaSiteKey } from '~/common/services/reCaptcha';

class ReCaptchaStoreClass {
    @observable siteKey = '';

    bootstrapStore() {
        // requests the reCaptcha site key
        autorun((reaction) => {
            getRecaptchaSiteKey().then((response) => {
                this.setSiteKey(response?.data?.siteKey);
                this.setScoreThreshold(response?.data?.scoreThreshold);
            });
            reaction.dispose();
        });
    }

    // setter functions
    @action setSiteKey(key) {
        if (typeof key === 'string') {
            this.siteKey = key;
        }
    }

    // setter functions
    @action setScoreThreshold(num) {
        if (typeof num === 'number') {
            this.scoreThreshold = num;
        }
    }
}

const reCaptchaStore = new ReCaptchaStoreClass();
export { reCaptchaStore, ReCaptchaStoreClass };
